<a class="skip-link" (click)="focusSkipLink()" tabindex="0" a11yKeyboardClickable>
    <ng-content></ng-content>
</a>
